import { render, staticRenderFns } from "./GraficoCadastroDonut.vue?vue&type=template&id=88a78434&scoped=true"
import script from "./GraficoCadastroDonut.vue?vue&type=script&lang=ts"
export * from "./GraficoCadastroDonut.vue?vue&type=script&lang=ts"
import style0 from "./GraficoCadastroDonut.vue?vue&type=style&index=0&id=88a78434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a78434",
  null
  
)

export default component.exports